<div class="modal-header">
    <h5 class="modal-title">Bulk Upload Error List</h5>
    <button type="button" class="close" data-dismiss="modal" (click)="closeModal('dismiss')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    

<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
               
                <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable">
                        <table class="table" id="formTable" *ngIf="basicDpList">
                            <thead>
                                <tr>
                                    <th scope="col" sortable="sno">Sheet No.</th>
                                    <th scope="col" sortable="name">Name</th>
                                    <th scope="col" sortable="email">Email ID</th>
                                    <th scope="col" sortable="proofType" >ID Proof Type</th>
                                    <th scope="col" sortable="proofNo" >ID Proof No.</th>
                                    <th scope="col" sortable="error" >Error</th>
                                </tr>                                
                            </thead>
                            <tbody>
                                <tr *ngFor = "let items of viewDpErrorList.duplicates | slice: (page-1) * pageSize : page * pageSize; let i=index">
                                    <td scope="row">{{items.sheet_no}}</td>
                                    <td scope="row">{{items.Dp_Name}}</td>
                                    <td scope="row">{{items.Email}}</td>
                                    <td scope="row">{{items.Document_Type}}</td>
                                    <td scope="row">{{items.Dp_Pan_No}}</td>
                                    <td scope="row" style="color:red;">{{items.message}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table" id="formTable" *ngIf="immediateDpList">
                            <thead>
                                <tr>
                                    <th scope="col" sortable="sno">Sheet No.</th>
                                    <th scope="col" sortable="sno">Email ID of Relative</th>
                                    <th scope="col" sortable="name">Name of Relative</th>
                                    <th scope="col" sortable="proofType" >ID Proof Type</th>
                                    <th scope="col" sortable="proofNo" >ID Proof No.</th>
                                    <th scope="col" sortable="error" >Error</th>
                                </tr>                                
                            </thead>
                            <tbody>
                                <tr *ngFor = "let items of viewDpErrorList.duplicates | slice: (page-1) * pageSize : page * pageSize; let i=index">
                                    <td scope="row">{{items.sheet_no}}</td>
                                    <td scope="row">{{items.Email_ID_of_Relative}}</td>
                                    <td scope="row">{{items.Name_of_Relative}}</td>
                                    <td scope="row">{{items.ID_Proof_Type_of_Relative}}</td>
                                    <td scope="row">{{items.ID_Proof_No_of_Relative}}</td>
                                    <td scope="row" style="color:red;">{{items.message}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="d-flex justify-content-between p-2">
                            <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="viewDpErrorList.duplicates?.length">
                            </ngb-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal('close')">Close</button>
</div>
